/*
 * - SABBANG PAHAYA GAMANEEYAN -
 * Created on Mon Jan 30 2023 5:00:25 AM
 *
 * By Kapila Rathnayaka
 *
 * Copyright (c) 2023 Kayble Zone Private Limited - Colombo Sri Lanka
 * Contact : http://www.kayblezone.lk - kapilarathnayaka@outlook.com
 */

import React, { useEffect, useState } from "react";
const algoliasearch = require("algoliasearch/lite");
import { useNavigate, useLocation } from "react-router-dom";
import { InstantSearch, SearchBox } from "react-instantsearch-dom";
import StickyNavbar from "./stickyNavbar";
import { update } from "lodash";

var theTextQuery = "";
const searchClient = algoliasearch(
  "07TRPO77DC",
  "5cfccb8ce8d3e8f3a1a35d96d942502b"
);
let searchTitle = "Search Content";
let contentType = "";
let label = "";
let placeholder_label = "";
let bgBackground = "bg-yellow";
let height = "h-44";
let marginTop = "0px";
let tipText = false;
let searchInput  =true;
let textColor = "text-white"
const SubSearch = () => {
  let hideSearchBox = false;
  const [isNavbarVisible] = useState(true);
  const [inputHeight] = useState(44);
  let location = useLocation();

  const navigate = useNavigate();

  if (window.location.pathname == "/results") {
    hideSearchBox = true;
    let tipText = false;
  }

  if (window.location.pathname.indexOf("/projects") == 0) {
    searchTitle = "Search (Projects) content";
    contentType = "projects";
    label = "Projects";
    placeholder_label = "Projects search";
    bgBackground = "bg-green";
    marginTop = "mt-36";
    height = "h-[290px]";
    tipText = true;
  } 
   if (window.location.pathname.indexOf("/organizations") == 0) {
    label = "Organisations";
    bgBackground = "bg-[#FFCD00]";
    marginTop = "-mt-10";
    height = "h-28";
    searchInput = false,
    textColor ="text-black"
   
  }

  if (window.location.pathname.indexOf("/publications") == 0) {
    searchTitle = "Search (Publications) content";
    contentType = "publications";
    label = "Publications";
    placeholder_label = "Publications search";
    bgBackground = "bg-blue";
    marginTop = "mt-36";
    height = "h-[290px]";
    tipText = true;
  }

  if (window.location.pathname.indexOf("/blogs") == 0) {
    searchTitle = "Search (Blogs) content";
    contentType = "blogs";
    label = "Blogs";
    placeholder_label = "Blogs search";
    bgBackground = "bg-cyan";
    height = "h-[290px]";
    marginTop = "mt-36";
    tipText = true;
  }

  if (window.location.pathname.indexOf("/resources") == 0) {
    searchTitle = "Search (Resources) content";
    contentType = "resources";
    label = "Resources";
    placeholder_label = "Resources search";
    bgBackground = "bg-orange";
    marginTop = "mt-36";
    height = "h-[290px]";
    tipText = true;
  }

  if (window.location.pathname.indexOf("/research-briefings") == 0) {
    searchTitle = "Search (Research Briefings) content";
    contentType = "research-briefings";
    label = "Research briefing";
    placeholder_label = "Search briefings";
    marginTop = "mt-36";
    height = "h-[290px]";
    bgBackground = "bg-parrot";
    tipText = true;
  }

  if (window.location.pathname.indexOf("/fireaustralia") == 0) {
    searchTitle = "Search (Fire Australia) content";
    contentType = "fireaustralia";
    label = "Fire Australia";
    placeholder_label = "Fire Australia search";
    marginTop = "mt-36";
    height = "h-[290px]";
    bgBackground = "bg-dark_pink";
  }
  if (window.location.pathname == "/") {
    contentType = "dev_kz_new";
    label = "";
    placeholder_label = "";
    bgBackground = "bg-yellow";
    height = "h-44";
    marginTop = "0px";
    tipText = false;
    searchInput=true;
  }

  const currentCT = window.location.pathname.replace("/", "");

  const updatequery = (e) => {
    if (e.target.value === "") return;
    if (e.key && e.key === "Enter") {
      navigate("/results?CT=" + currentCT + "&query=" + theTextQuery);
    }
    theTextQuery = e.target.value;
  };

  

  return (
    <>
      {!hideSearchBox ? (
        <>
          <header
            style={{ zIndex: "2" }}
            className={` bg-white transition-opacity duration-300 ${
              isNavbarVisible ? "opacity-100" : "opacity-0"
            }`}
          > 
            <div className="tmpsearchbox">
              <div className={` ${height}  h-${inputHeight} ${bgBackground}`}>
                <div className={`h-${inputHeight}`}>
                  <div className="flex h-[180px] items-center flex-col justify-center rounded-lg  ">
                    <h1
                      className={`mb-4 ${marginTop} ${textColor} `}
                      style={{
                        textAlign: "center",
                        font: "normal normal normal 52px/60px Titillium Web",
                        letterSpacing: "0px",
                        opacity: "1",
                      }}
                    >
                  {label === 'Organisations' ? " " : label}   
                    </h1>
                      
                    <StickyNavbar
                      placeholder_label={placeholder_label}
                      updatequery={updatequery}
                      bgBackground={bgBackground}
                      searchInput = {searchInput}
                      label={label}
                    />
                
                   
                    {tipText ? (
                      <div>
                        <div
                          className="flex gap-1 text-container"
                          id="text-container"
                        >
                          <div className="tip_text">TIP</div>
                          <div className="tip">
                            FOR QUICKEST RESULTS USE THE SEARCH FEATURE ABOVE
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
          </header>
        </>
      ) : null}
    </>
  );
};

export default SubSearch;
